module.exports = __webpack_public_path__ + "static/deliveroo.bbc1df66.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/documents/pdfs/deliveroo.pdf
// module id = 1531
// module chunks = 157636680307020